// extracted by mini-css-extract-plugin
export default {"container":"text-block-body_container__PRJKW"};